import React from 'react';
import JobCardsContainer from '../../Componant/JobSearch/JobCardView';

const JobCards = () => {
  return (
    <div className='page-body'>
      <JobCardsContainer />
    </div>
  );
};

export default JobCards;
